import { validateNumber, numberErrorCode, getNumberErrorMsg, bidStrategyOptionKeys } from '@bingads-webui-campaign/hotel-common-upsert';
import appConfig from '@bingads-webui-component-legacy/config/index';

export const fields = {
  ManualCpc: 'ManualCpc',
  PercentCpc: 'PercentCpc',
  Commission: 'Commission',
  AdGroupBid: 'AdGroupBid',
  AdGroupPercentBid: 'AdGroupPercentBid',
  AdGroupCommissionRate: 'AdGroupCommissionRate',
};

export const bidStrategyTypeValueMap = {
  ManualCpc: '',
  PercentCpc: 'PercentMaxCpc',
  Commission: 'CommissionRate',
};

export const bidStrategyOptions = (i18n, isPayPerStayEnabled) => [
  {
    key: bidStrategyOptionKeys.ManualCpc, text: i18n.getString(_TL_('Fixed bid per night (per click)')),
  },
  {
    key: bidStrategyOptionKeys.PercentCpc, text: i18n.getString(_TL_('Percentage of room price (per click)')),
  },
  ...(isPayPerStayEnabled ? [{ key: bidStrategyOptionKeys.Commission, text: i18n.getString(_TL_('Percentage of room price (per stay)')) }] : []),
];

const percentageOrBidConst = {
  min: 0,
  max: 1000,
};


export const getAdGroupBidMinMax = ({ selectedKey, bidStrategy, serverContext }) => {
  const key = selectedKey || bidStrategy.option;
  // align the range with search ad group campaign as MT create it with the same flow.
  const min = (serverContext && serverContext.KeywordBidRange && serverContext.KeywordBidRange.FloorValue) || 0.01;
  const max = (serverContext && serverContext.KeywordBidRange && serverContext.KeywordBidRange.CeilingValue) || 1000;
  switch (key) {
    case bidStrategyOptionKeys.ManualCpc:
      return { min, max };
    case bidStrategyOptionKeys.PercentCpc:
      return { min: appConfig.get('KeywordPercentCpcBidRange') && appConfig.get('KeywordPercentCpcBidRange').FloorValue, max: appConfig.get('KeywordPercentCpcBidRange') && appConfig.get('KeywordPercentCpcBidRange').CeilingValue };
    case bidStrategyOptionKeys.Commission:
      return { min: appConfig.get('KeywordCommissionRateRange') && appConfig.get('KeywordCommissionRateRange').FloorValue, max: appConfig.get('KeywordCommissionRateRange') && appConfig.get('KeywordCommissionRateRange').CeilingValue };
    default:
      return null;
  }
};

export const validateAdGroupBid = ({
  selectedKey, bidStrategy, min, max,
}) => {
  const key = selectedKey || bidStrategy.option;
  switch (key) {
    case bidStrategyOptionKeys.ManualCpc:
      return validateNumber({
        value: bidStrategy[fields.AdGroupBid], min, max, digitLength: 2,
      });
    case bidStrategyOptionKeys.PercentCpc:
      return validateNumber({
        value: bidStrategy[fields.AdGroupPercentBid], min, max, digitLength: 2, notIncludeMin: true,
      });
    case bidStrategyOptionKeys.Commission:
      return validateNumber({
        value: bidStrategy[fields.AdGroupCommissionRate], min, max, notRequired: true, digitLength: 2, notIncludeMin: true,
      });
    default:
      return null;
  }
};

export const getBidStrategyMinMax = ({ selectedKey, bidStrategy, serverContext }) => {
  const key = selectedKey || bidStrategy.option;
  const min = (serverContext && serverContext.ProductGroupBidRange && serverContext.ProductGroupBidRange.FloorValue) || 0.01;
  const max = (serverContext && serverContext.ProductGroupBidRange && serverContext.ProductGroupBidRange.CeilingValue) || 1000;
  switch (key) {
    case bidStrategyOptionKeys.PercentCpc:
      return { min, max };
    case bidStrategyOptionKeys.Commission:
      return { min: appConfig.get('KeywordCommissionRateRange') && appConfig.get('KeywordCommissionRateRange').FloorValue, max: appConfig.get('KeywordCommissionRateRange') && appConfig.get('KeywordCommissionRateRange').CeilingValue };
    case bidStrategyOptionKeys.ManualCpc:
    default:
      return null;
  }
};

export const validateBidStrategy = ({
  selectedKey, bidStrategy, min, max,
}) => {
  const key = selectedKey || bidStrategy.option;
  switch (key) {
    case bidStrategyOptionKeys.ManualCpc:
      return null;
    case bidStrategyOptionKeys.PercentCpc:
      return validateNumber({
        value: bidStrategy[key],
        min,
        max,
        notRequired: true,
        digitLength: 2,
      });
    case bidStrategyOptionKeys.Commission:
      return validateNumber({
        value: bidStrategy[key], min, max, digitLength: 2, notIncludeMin: true,
      });
    default:
      return null;
  }
};

export const isBidStrategyValid = ({
  selectedKey, bidStrategy, serverContext, isCreation,
}) => {
  const valid = validateBidStrategy({ selectedKey, bidStrategy, ...getBidStrategyMinMax({ selectedKey, bidStrategy, serverContext }) }) == null;
  if (valid && isCreation) {
    return validateAdGroupBid({ selectedKey, bidStrategy, ...getAdGroupBidMinMax({ selectedKey, bidStrategy, serverContext }) }) == null;
  }
  return valid;
};

export const getPercentageOrBidErrorMsg = ({
  code, i18n, min = percentageOrBidConst.min, max = percentageOrBidConst.max, isPercent,
}) => {
  switch (code) {
    case numberErrorCode.RequiredField:
      if (isPercent) {
        return i18n.getString(_TL_('Enter a percentage'));
      }
      return i18n.getString(_TL_('Enter a bid'));
    default:
      return getNumberErrorMsg({
        code, i18n, min, max,
      });
  }
};
